"use client";

import { constructCalendarLink } from "@/apiUtils/commonUtils";
import { CalendarEventDetails } from "@/common/lib/types";
import Modal from "@/components/ui/modal_new/Modal";
import Image from "next/image";
import { CLink } from "@/components/common/customLink/CustomLink";
import { FC } from "react";

type AddToCalendarModalProps = {
  title?: string;
  isOpen: boolean;
  eventDetails: CalendarEventDetails;
  toggle: () => void;
};

const AddToCalendarModal: FC<AddToCalendarModalProps> = ({
  isOpen,
  title,
  eventDetails,
  toggle,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={toggle} slots={{ root: { className: "z-[25]" } }}>
      <div className="font-semibold">{title}</div>
      <div style={{ paddingRight: "2.5rem", paddingLeft: "2.5rem", paddingBottom: "2rem" }}>
        <div className="justify-content-center mt-8 flex gap-12">
          <div className="col-auto">
            <CLink href={constructCalendarLink("google", eventDetails)} target="_blank">
              <Image
                src={"/magrabi/images/eye-test/google.svg"}
                alt="google"
                width={54}
                height={54}
              />
            </CLink>
          </div>
          <div className="col-auto">
            <CLink href={constructCalendarLink("outlook", eventDetails)} target="_blank">
              <Image
                src={"/magrabi/images/eye-test/outlook.svg"}
                alt="outlook"
                width={54}
                height={54}
              />
            </CLink>
          </div>
          <div className="col-auto">
            <CLink href={constructCalendarLink("yahoo", eventDetails)} target="_blank">
              <Image
                src={"/magrabi/images/eye-test/yahoo.svg"}
                alt="yahoo"
                width={54}
                height={54}
              />
            </CLink>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default AddToCalendarModal;
